module.exports = __webpack_public_path__ + "static/media/parallax2.02d5624d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/parallax2.jpg
// module id = 95
// module chunks = 0